export const LOGIN = 'login';
export const CAMMS_RISK = 'cammsrisk';
export const CAMMS_SERVICE = 'service';
export const CAMMS_INCIDENT = 'incident';
export const ACTION_DETAIL = 'action-detail';
export const FRAMEWORK = 'framework';
export const FORGOT_PASSWORD = 'forgot-password';
export const RESET_PASSWORD = 'reset-password';
export const SETTINGS = 'settings';
export const CREATE_RISK = 'create-risk';
export const CAMMS_RISK_REGISTER = 'risk-register';
export const LANDING_PAGE = 'landing-page';
export const LOCALIZATION_ADMIN = 'localization-admin';
export const INTERNAL_ADMIN = 'internal-admin';
export const DSM_ADMIN = 'dsm-admin';
export const OTHER_APP = 'other-app';
export const MY_SETTING = 'my-setting';
export const AUTH = 'auth';
export const HEAT_MAP = 'heatmap-dashboard';
export const SUPPORT = 'support';
export const ACCESS_DENIED = 'access-denied';
export const PRODUCT_NOT_ACTIVATED = 'product-not-activated';
export const ACTION = 'action';
export const PRODUCT_ACTIVATION_VIA_LICENSE_DENIED =
    'product-activation-via-license-denied';
export const INVALID_TOKEN = 'token-expired';
export const ADMINISTRATION = 'administration';
export const CONFIGURATION = 'configuration';
export const PROJECTS = 'projects';
export const KEY_RISK_INDICATORS = 'key-risk-indicators';
export const RISK_ADMINISTRATION = 'risk-administration';
export const AUDIT_ADMINISTRATION = 'audit-administration';
export const DASHBOARD = 'dashboard';

// #region IPM Menu items
export const PROJECT_DOCUMENTREGISTER = 'PROJECT_DOCUMENTREGISTER';
export const PROJECT_BUSINESSREQUIRMENT = 'PROJECT_BUSINESSREQUIRMENT';
export const PROJECT_PROJECTQUICKUPDATE = 'PROJECT_PROJECTQUICKUPDATE';

export const PROJECT_WORKSPACE = 'PROJECT_WORKSPACE';
export const PROJECT_WORKSPACE_DOWNLOADS = 'PROJECT_WORKSPACE_DOWNLOADS';
export const PROJECT_WORKSPACE_SETTINGS = 'PROJECT_WORKSPACE_SETTINGS';

export const PROJECT_RESOURCEMANAGER = 'PROJECT_RESOURCEMANAGER';
export const PROJECT_RESOURCEMANAGER_PROJECTUTILIZATION =
    'PROJECT_RESOURCEMANAGER_PROJECTUTILIZATION';
export const PROJECT_RESOURCEMANAGER_RESOURCEUTILIZATION =
    'PROJECT_RESOURCEMANAGER_RESOURCEUTILIZATION';
export const PROJECT_RESOURCEMANAGER_ALLOCATIONOVERVIEW =
    'PROJECT_RESOURCEMANAGER_ALLOCATIONOVERVIEW';

export const PROJECT_FINANCIALMANAGEMENT = 'PROJECT_FINANCIALMANAGEMENT';
export const PROJECT_FINANCIALMANAGEMENT_VENDORS =
    'PROJECT_FINANCIALMANAGEMENT_VENDORS';
export const PROJECT_FINANCIALMANAGEMENT_FORCASTCONFIGURATIONS =
    'PROJECT_FINANCIALMANAGEMENT_FORCASTCONFIGURATIONS';
export const PROJECT_FINANCIALMANAGEMENT_PORTFOLIOCOSTTRACKER =
    'PROJECT_FINANCIALMANAGEMENT_PORTFOLIOCOSTTRACKER';
export const PROJECT_FINANCIALMANAGEMENT_REGISTERCONFIGURATIONS =
    'PROJECT_FINANCIALMANAGEMENT_REGISTERCONFIGURATIONS';

export const PROJECT_FRAMEWORK_PROJECTSETTINGS =
    'PROJECT_FRAMEWORK_PROJECTSETTINGS';
export const PROJECT_FRAMEWORK_PROJECTWORKFLOWS =
    'PROJECT_FRAMEWORK_PROJECTWORKFLOWS';
export const PROJECT_FRAMEWORK_FIELDCONFIGURATION =
    'PROJECT_FRAMEWORK_FIELDCONFIGURATION';
export const PROJECT_FRAMEWORK_LISTCONFIGURATION =
    'PROJECT_FRAMEWORK_LISTCONFIGURATION';
export const PROJECT_FRAMEWORK_PERMISSIONCONFIGURATION =
    'PROJECT_FRAMEWORK_PERMISSIONCONFIGURATION';
export const PROJECT_FRAMEWORK_PROJECTFIELDCONFIGURATION =
    'PROJECT_FRAMEWORK_PROJECTFIELDCONFIGURATION';
export const PROJECT_FRAMEWORK_APICONFIGURATION =
    'PROJECT_FRAMEWORK_APICONFIGURATION';
export const PROJECT_FRAMEWORK_MICROSOFTTEAMSCONFIGURATION =
    'PROJECT_FRAMEWORK_MICROSOFTTEAMSCONFIGURATION';
export const PROJECT_FRAMEWORK_HIERARCHY = 'PROJECT_FRAMEWORK_HIERARCHY';
export const PROJECT_FRAMEWORK_HIERARCHYCONFIGURATION =
    'PROJECT_FRAMEWORK_HIERARCHYCONFIGURATION';
export const PROJECT_FRAMEWORK_PRIORITISATION_CONFIGURATION =
    'PROJECT_FRAMEWORK_PRIORITISATION_CONFIGURATION';
export const PROJECT_FRAMEWORK_IDEAS_PORTAL_CONFIGURATION =
    'PROJECT_FRAMEWORK_IDEAS_PORTAL_CONFIGURATION';
export const PROJECT_FRAMEWORK_BUSINESS_REQUIREMENT_SETTINGS =
    'PROJECT_FRAMEWORK_BUSINESS_REQUIREMENT_SETTINGS';
export const PROJECT_FRAMEWORK = 'PROJECT_FRAMEWORK';

export const PROJECT_TIMEENTRY = 'PROJECT_TIMEENTRY';
export const PROJECT_TIMEENTRY_TIMEENTRY = 'PROJECT_TIMEENTRY_TIMEENTRY';
export const PROJECT_TIMEENTRY_TIMEENTRYSUMMARY =
    'PROJECT_TIMEENTRY_TIMEENTRYSUMMARY';
export const PROJECT_TIMEENTRY_TIMEENTRYAPPROVAL =
    'PROJECT_TIMEENTRY_TIMEENTRYAPPROVAL';
export const PROJECT_TIMEENTRY_TIMECOSTUTILIZATION =
    'PROJECT_TIMEENTRY_TIMECOSTUTILIZATION';
export const PROJECT_TIMEENTRY_TIMEUTILIZATIONANALYSIS =
    'PROJECT_TIMEENTRY_TIMEUTILIZATIONANALYSIS';

export const PROJECT_REPORTS_REPORTUPLOADER = 'PROJECT_REPORTS_REPORTUPLOADER';
export const PROJECT_REPORTS_REPORTUPLOADERSETUP =
    'PROJECT_REPORTS_REPORTUPLOADERSETUP';

export const PROJECT_EXECUTIVEEXPLORER = 'PROJECT_EXECUTIVEEXPLORER';
export const PROJECT_EXECUTIVEEXPLORER_PROJECTMILESTONES =
    'PROJECT_EXECUTIVEEXPLORER_PROJECTMILESTONES';
export const PROJECT_EXECUTIVEEXPLORER_PROJECTCHARTS =
    'PROJECT_EXECUTIVEEXPLORER_PROJECTCHARTS';
export const PROJECT_EXECUTIVEEXPLORER_PORTFOLIOPROJECTVIEW =
    'PROJECT_EXECUTIVEEXPLORER_PORTFOLIOPROJECTVIEW';
export const PROJECT_EXECUTIVEEXPLORER_RESOURCEALLOCATION =
    'PROJECT_EXECUTIVEEXPLORER_RESOURCEALLOCATION';
export const PROJECT_EXECUTIVEEXPLORER_HIERARCHYSUMMARY =
    'PROJECT_EXECUTIVEEXPLORER_HIERARCHYSUMMARY';
export const PROJECT_EXECUTIVEEXPLORER_PROJECTMAP =
    'PROJECT_EXECUTIVEEXPLORER_PROJECTMAP';
export const PROJECT_EXECUTIVEEXPLORER_FINANCIALTARGET =
    'PROJECT_EXECUTIVEEXPLORER_FINANCIALTARGET';
export const PROJECT_EXECUTIVEEXPLORER_EXECUTIVEDASHBOARD =
    'PROJECT_EXECUTIVEEXPLORER_EXECUTIVEDASHBOARD';
export const PROJECT_EXECUTIVEEXPLORER_SCURVEDASHBOARD =
    'PROJECT_EXECUTIVEEXPLORER_SCURVEDASHBOARD';
export const PROJECT_EXECUTIVEEXPLORER_ACCOUNTSUMMARY =
    'PROJECT_EXECUTIVEEXPLORER_ACCOUNTSUMMARY';
export const PROJECT_EXECUTIVEEXPLORER_PROJECTBUDGET =
    'PROJECT_EXECUTIVEEXPLORER_PROJECTBUDGET';
export const PROJECT_FRAMEWORK_BUSINESS_REQUIREMENT =
    'PROJECT_FRAMEWORK_BUSINESS_REQUIREMENT';

// #endregion IPM Menu items

// #region Sycle Menu items

export const InterplanAdministration_Users_StaffGrouping =
    'InterplanAdministration_Users_StaffGrouping';
export const InterplanAdministration_Users_UserList =
    'InterplanAdministration_Users_UserList';
export const InterplanAdministration_Users_ManageUsers =
    'InterplanAdministration_Users_ManageUsers';
export const InterplanAdministration_Users_ManageAppraisalSecurity =
    'InterplanAdministration_Users_ManageAppraisalSecurity';
export const InterplanAdministration_Users = 'InterplanAdministration_Users';
export const InterplanAdministration_RoleManagement =
    'InterplanAdministration_RoleManagement';
export const InterplanTools_FinancialInterface_ImportAccountData =
    'InterplanTools_FinancialInterface_ImportAccountData';
export const InterplanTools_FinancialInterface_MapAccounts =
    'InterplanTools_FinancialInterface_MapAccounts';
export const InterplanTools_FinancialInterface_SplitAccounts =
    'InterplanTools_FinancialInterface_SplitAccounts';
export const InterplanTools_FinancialInterface_ImportToCammstrategy =
    'InterplanTools_FinancialInterface_ImportToCammstrategy';
export const SycleFinancialInterface = 'SycleFinancialInterface';
export const SycleReportingTools_ReportUploaderSettings =
    'SycleReportingTools_ReportUploaderSettings';
export const SycleReportingTools_ReportUploader =
    'SycleReportingTools_ReportUploader';
export const SycleReportingTools = 'SycleReportingTools';
export const CustomHierarchies_HierarchyConfiguration =
    'CustomHierarchies_HierarchyConfiguration';
export const CustomHierarchies_Hierarchy = 'CustomHierarchies_Hierarchy';
export const CustomHierarchies_ShowParentsInHierarchy =
    'CustomHierarchies_ShowParentsInHierarchy';
export const CustomHierarchies = 'CustomHierarchies';
export const CustomHierarchies_Hierarchy_NavigationPad =
    'CustomHierarchies_Hierarchy_NavigationPad';
export const InterplanTools_Executive_Build = 'InterplanTools_Executive_Build';
export const InterplanTools_Executive_Build_SignOff =
    'InterplanTools_Executive_Build_SignOff';
export const SycleExecutiveUpdatePortal = 'SycleExecutiveUpdatePortal';
export const SycleExecutiveTools = 'SycleExecutiveTools';
export const InterplanTools_Rollover_Start = 'InterplanTools_Rollover_Start';
export const InterplanTools_Rollover_Complete =
    'InterplanTools_Rollover_Complete';
export const InterplanTools_Rollover_Rollback =
    'InterplanTools_Rollover_Rollback';
export const InterplanTools_Rollover_ArchivePeriod =
    'InterplanTools_Rollover_ArchivePeriod';
export const SycleRollover = 'SycleRollover';
export const InterplanAdministration_Settings =
    'InterplanAdministration_Settings';
export const InterplanAdministration_Configuration_SpellCheck =
    'InterplanAdministration_Configuration_SpellCheck';
export const InterplanAdministration_Configuration_SWOTType =
    'InterplanAdministration_Configuration_SWOTType';
export const InterplanAdministration_Configuration_ActionProgressThreshold =
    'InterplanAdministration_Configuration_ActionProgressThreshold';
export const InterplanAdministration_Configuration_BudgetThreshold =
    'InterplanAdministration_Configuration_BudgetThreshold';
export const InterplanAdministration_Configuration_EISSettings =
    'InterplanAdministration_Configuration_EISSettings';
export const InterplanAdministration_Configuration_ExecutiveCommentType =
    'InterplanAdministration_Configuration_ExecutiveCommentType';
export const InterplanAdministration_OrganisationalReports =
    'InterplanAdministration_OrganisationalReports';
export const InterplanAdministration_Configuration_QuickUpdateGridSettings =
    'InterplanAdministration_Configuration_QuickUpdateGridSettings';
export const InterplanAdministration_Configuration =
    'InterplanAdministration_Configuration';
export const InterplanAdministration = 'InterplanAdministration';
export const InterplanAdministration_DefaultLocation =
    'InterplanAdministration_DefaultLocation';
export const InterplanAdministration_SetupShapefiles =
    'InterplanAdministration_SetupShapefiles';
export const InterplanAdministration_GISAdministration =
    'InterplanAdministration_GISAdministration';
export const InterplanAdministration_Modules_Revumap =
    'InterplanAdministration_Modules_Revumap';
export const InterplanAdministration_Modules =
    'InterplanAdministration_Modules';
export const InterplanAdministration_OtherTools_Scheduling_Prioritisation =
    'InterplanAdministration_OtherTools_Scheduling_Prioritisation';
export const InterplanAdministration_OtherTools =
    'InterplanAdministration_OtherTools';
// #endregion Sycle Menu items
